import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveAddressesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveRegistrationAddressesParam } from 'api/types/params';

import { parseLegalClient } from './helpers';

export const useLegalClientSaveAddresses = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveAddressesMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientSaveAddresses
      ? parseLegalClient(data.legalClientSaveAddresses)
      : undefined,
    loading,
    error,
    saveAddresses: useCallback(
      async (id: string, params: LegalClientSaveRegistrationAddressesParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.legalClientSaveAddresses
          ? parseLegalClient(res.data.legalClientSaveAddresses)
          : undefined;
      },
      [handle]
    ),
  };
};
